import { saveToStorage } from '@/lib/storage'
import { useMMKVNumber } from 'react-native-mmkv'

/**
 * The appointment whose results the patient has opened. The home hero shows for results
 * newer than this; the id is global, so a different account on the same device never
 * inherits the mark.
 */
export const RESULTS_SEEN_KEY = 'home.results-seen-appointment-id'

export const markResultsSeen = (appointmentId: number) =>
	saveToStorage(RESULTS_SEEN_KEY, appointmentId)

/** Reactive: Home re-renders the moment the score screen writes the mark. */
export const useResultsSeen = () => useMMKVNumber(RESULTS_SEEN_KEY)[0]
